"use client";

import { MessageCircleQuestion } from "lucide-react";

interface FollowUpQuestionsProps {
  questions: string[];
  onSelect: (question: string) => void;
}

export function FollowUpQuestions({ questions, onSelect }: FollowUpQuestionsProps) {
  if (!questions || questions.length === 0) return null;

  return (
    <div className="px-4 py-2">
      <div className="mb-2 flex items-center gap-1.5">
        <MessageCircleQuestion className="h-3.5 w-3.5 text-violet-400" />
        <span className="text-xs font-medium text-gray-400">이런 질문은 어떠세요?</span>
      </div>
      <div className="flex flex-col gap-1.5">
        {questions.map((q) => (
          <button
            key={q}
            onClick={() => onSelect(q)}
            className="rounded-xl border border-gray-200 bg-white px-3.5 py-2.5 text-left text-sm text-gray-600 transition-all hover:border-violet-300 hover:bg-violet-50 hover:text-violet-700 hover:shadow-sm"
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
